import { Message } from '@messageformat/react';
import { font, space } from '@op/opds.tokens';
import ScoreMeter from './ScoreMeter';
import classes from './Score.module.scss';
import { getFeedbackLevel } from '../DiversityAnalyzer/utils';

interface Props {
  scorePercent: number;
  showText: boolean;
}

const Score = ({ scorePercent, showText }: Props): JSX.Element => {
  const feedbackLevel = getFeedbackLevel(scorePercent);
  return (
    <div className={classes.container}>
      <h5
        style={{
          marginBottom: space.xxs,
          fontWeight: font.weight.bold,
        }}
      >
        <Message id="course7.score.label" />
      </h5>
      <ScoreMeter scorePercent={scorePercent} />
      <div style={{ margin: 0, opacity: showText ? '1' : '0' }}>
        <Message id={`course7.score.level${feedbackLevel}`} />
      </div>
    </div>
  );
};

export default Score;
